/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 526
// module chunks = 17 23